import { apiClient } from '@/lib/api/client'

export interface LogoutAssignmentPreviewTicket {
  id: number
  ticket_number: string | null
  subject: string | null
  status: string | null
  default_retain: boolean
}

export async function getLogoutAssignmentPreview(): Promise<LogoutAssignmentPreviewTicket[]> {
  const res = await apiClient.get<{ data: LogoutAssignmentPreviewTicket[] }>(
    '/logout/assignment-preview',
  )
  return Array.isArray(res.data?.data) ? res.data.data : []
}

export function formatTicketStatusLabel(status: string | null | undefined): string {
  if (!status) return 'Unknown'
  return status
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}
